import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h5>{`第一軌：開發流程與實務`}</h5>
    <ul>
      <li parentName="ul">{`是否在覺得開發過程中，遇到許多繁雜及不可預期的狀況。`}</li>
      <li parentName="ul">{`在本軌議程中，從需求聚焦、團隊共識的建立、塑模的手法及開發流程實務與改善等方向，切入問題的核心，找出解決問題的施力點。`}</li>
      <li parentName="ul">{`在本軌所有的議程中，環繞著團隊在開發產品/專案時，如何提升團隊的生產力，並將繁雜瑣碎升華至簡單精確的高效開發。`}</li>
      <li parentName="ul">{`內容包含但不限於:`}<ol parentName="li">
          <li parentName="ol">{`敏捷/極致開發方法`}</li>
          <li parentName="ol">{`塑模手法`}</li>
          <li parentName="ol">{`開發流程改善實例`}</li>
          <li parentName="ol">{`需求聚焦`}</li>
          <li parentName="ol">{`建立團隊共識`}</li>
        </ol></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      